import { useRef, useCallback } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import ResizeObserver from 'resize-observer-polyfill';

const middleEllipsis = (containerWidth, childNode) => {
  if (!childNode)
    return;
  const childWidth = childNode.offsetWidth;
  if (childWidth > containerWidth) {
    const txt = childNode.textContent || "";
    const txtChars = txt.length;
    const avgLetterSize = childWidth / txtChars;
    const canFit = containerWidth / avgLetterSize;
    const delEachSide = (txtChars - canFit + 3) / 2;
    const leftPart = Math.floor(txtChars / 2 - delEachSide);
    const rightPart = Math.ceil(txtChars / 2 + delEachSide);
    childNode.textContent = `${txt.substring(0, leftPart)}...${txt.substring(rightPart)}`;
  }
};
const useTruncate = (props) => {
  const { mode } = props;
  if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
  }
  const targetRef = useRef();
  const onResize = useCallback((width) => {
    var _a, _b, _c;
    if (mode !== "middle")
      return;
    const childNode = (_a = targetRef == null ? void 0 : targetRef.current) == null ? void 0 : _a.childNodes[0];
    if (childNode) {
      if ((_b = targetRef == null ? void 0 : targetRef.current) == null ? void 0 : _b.hasAttribute("title")) {
        childNode.textContent = (_c = targetRef == null ? void 0 : targetRef.current) == null ? void 0 : _c.getAttribute("title");
      }
      middleEllipsis(width, childNode);
    }
  }, [mode]);
  const { ref: wrapperRef } = useResizeDetector({ onResize, targetRef });
  return { wrapperRef };
};

export { middleEllipsis, useTruncate };
//# sourceMappingURL=useTruncate.es.js.map
